import TableLoader from 'components/commons/TableLoader'
import BeSafeContainer from 'components/commons/BeSafeContainer'
import ConfigurationTitle from './ConfigurationTitle'

const ConfigurationSection = (props) => {

  return (
    <div className={ props.className ?? "d-flex flex-column h-100 minh-300"}>
      <ConfigurationTitle text={props.title} buttons={props.headerButtons}/>
      <TableLoader visible={props.loading} rows={7} />
      <BeSafeContainer visible={!props.loading}>
        {props.children}
      </BeSafeContainer>
    </div>
  );
};

export default ConfigurationSection;
